import { usePortalFeatures } from 'vet-bones/utils/portal';

import { ReduxState } from 'src/store/types';
import { useDefaultPortalConnection } from 'src/utils/hooks/useDefaultPortalConnection';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const useIsVoiceboxEnabled = () => {
  const portalConnection = useDefaultPortalConnection();
  const voiceboxDbLimitByConnectionId = useReduxSelector(
    (state: ReduxState) => state.connections.voiceboxDbLimitByConnectionId
  );

  const portalFeatures = usePortalFeatures();
  const isVoiceboxEnabledUser = portalFeatures.voicebox;

  return Boolean(
    voiceboxDbLimitByConnectionId[portalConnection?.id || ''] &&
      isVoiceboxEnabledUser
  );
};
